const SvgIconTokenized = (props) => (
  <svg viewBox="0 0 120 105" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M60 105c33.137 0 60-9.907 60-22.128S93.137 60.743 60 60.743 0 70.651 0 82.873C0 95.092 26.863 105 60 105Z"
      fill="#29A964"
    />
    <path
      d="M60 45.123c33.137 0 60-10.1 60-22.561S93.137 0 60 0 0 10.1 0 22.56s26.863 22.563 60 22.563Z"
      fill="#F2D6BB"
    />
    <path
      d="M60 75.495c33.137 0 60-10.102 60-22.562S93.137 30.37 60 30.37 0 40.472 0 52.933c0 12.46 26.863 22.562 60 22.562Z"
      fill="#3763FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M105.077 67.664c-11.043 4.728-27.285 7.716-45.392 7.716-18.107 0-34.349-2.987-45.392-7.716 11.043-4.728 27.285-7.715 45.392-7.715 18.107 0 34.349 2.987 45.392 7.715Z"
      fill="#2525D7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M105.077 38.044c-11.043 4.728-27.284 7.716-45.392 7.716-18.107 0-34.348-2.988-45.391-7.716 11.043-4.728 27.284-7.715 45.391-7.715 18.108 0 34.35 2.987 45.392 7.715Z"
      fill="#F06C22"
    />
  </svg>
);

export default SvgIconTokenized;
